module.exports = __webpack_public_path__ + "static/media/trash.55f1a5f7.png";